const HOUR_BUTTON_HEIGHT = 38;
const HOUR_LIST_ROW_GAP = 16;
const COLLAPSED_ROWS = 2;
const COLLAPSED_HEIGHT =
	COLLAPSED_ROWS * HOUR_BUTTON_HEIGHT + (COLLAPSED_ROWS - 1) * HOUR_LIST_ROW_GAP;

export {HOUR_BUTTON_HEIGHT, HOUR_LIST_ROW_GAP, COLLAPSED_HEIGHT};
